// This file contains unstable semantic conventions for OpenTelemetry attributes
// that are not covered by @opentelemetry/semantic-conventions

export const ATTR_SERVICE_NAMESPACE = 'service.namespace' as const
